module.exports = __webpack_public_path__ + "static/media/sunny1.ef1ab747.jpg";